var _ellipse, _ellipse2, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPublic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20,
    cy: 20.0664,
    rx: 20,
    ry: 19.9336,
    fill: "#C7D4E4"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2947_2311",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 20,
    cy: 19.9336,
    rx: 20,
    ry: 19.9336,
    fill: "#C7D4E4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2947_2311)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.4004,
    cy: 20.9965,
    rx: 20,
    ry: 19.9336,
    fill: "#DDEBFD"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 15.6809,
    cy: 12.3501,
    rx: 3.73563,
    ry: 3.65162,
    fill: "#E2AA73"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.2547,
    cy: 12.3501,
    rx: 3.16092,
    ry: 3.65162,
    fill: "#FBBD80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.21484 22.4672C9.21484 18.8964 12.1096 16.0017 15.6804 16.0017V16.0017C19.2512 16.0017 22.1459 18.8964 22.1459 22.4672V32.7562H9.21484V22.4672Z",
    fill: "#3EAC5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2266 21.4615C11.2266 18.4461 13.671 16.0017 16.6863 16.0017V16.0017C19.7017 16.0017 22.1461 18.4461 22.1461 21.4615V32.7562H11.2266V21.4615Z",
    fill: "#45BF64"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 26.5989,
    cy: 12.3501,
    rx: 3.73563,
    ry: 3.65162,
    fill: "#E2AA73"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 27.1726,
    cy: 12.3501,
    rx: 3.16092,
    ry: 3.65162,
    fill: "#FBBD80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1328 22.4672C20.1328 18.8964 23.0275 16.0017 26.5983 16.0017V16.0017C30.1691 16.0017 33.0638 18.8964 33.0638 22.4672V32.7562H20.1328V22.4672Z",
    fill: "#0083B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1445 21.4615C22.1445 18.4461 24.589 16.0017 27.6043 16.0017V16.0017C30.6197 16.0017 33.0641 18.4461 33.0641 21.4615V32.7562H22.1445V21.4615Z",
    fill: "#0091CA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 9.9329,
    cy: 22.5173,
    rx: 3.73563,
    ry: 3.65162,
    fill: "#E2AA73"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 10.5066,
    cy: 22.5173,
    rx: 3.16092,
    ry: 3.65162,
    fill: "#FBBD80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.4668 32.6347C3.4668 29.0639 6.36151 26.1692 9.93231 26.1692V26.1692C13.5031 26.1692 16.3978 29.0639 16.3978 32.6347V42.9237H3.4668V32.6347Z",
    fill: "#0083B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.47852 31.629C5.47852 28.6136 7.92294 26.1692 10.9383 26.1692V26.1692C13.9536 26.1692 16.3981 28.6136 16.3981 31.629V42.9237H5.47852V31.629Z",
    fill: "#0091CA"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.136,
    cy: 22.5176,
    rx: 3.73563,
    ry: 3.65162,
    fill: "#E2AA73"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 20.7097,
    cy: 22.5176,
    rx: 3.16092,
    ry: 3.65162,
    fill: "#FBBD80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6699 32.6347C13.6699 29.0639 16.5646 26.1692 20.1354 26.1692V26.1692C23.7062 26.1692 26.601 29.0639 26.601 32.6347V42.9237H13.6699V32.6347Z",
    fill: "#DD404D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6816 31.629C15.6816 28.6136 18.1261 26.1692 21.1414 26.1692V26.1692C24.1568 26.1692 26.6012 28.6136 26.6012 31.629V42.9237H15.6816V31.629Z",
    fill: "#F54756"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.3352,
    cy: 22.5176,
    rx: 3.73563,
    ry: 3.65162,
    fill: "#E2AA73"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 30.909,
    cy: 22.5176,
    rx: 3.16092,
    ry: 3.65162,
    fill: "#FBBD80"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8691 32.6347C23.8691 29.0639 26.7639 26.1692 30.3347 26.1692V26.1692C33.9055 26.1692 36.8002 29.0639 36.8002 32.6347V42.9237H23.8691V32.6347Z",
    fill: "#E5C53B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.8809 31.629C25.8809 28.6136 28.3253 26.1692 31.3406 26.1692V26.1692C34.356 26.1692 36.8004 28.6136 36.8004 31.629V42.9237H25.8809V31.629Z",
    fill: "#FEDB41"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublic);
export default __webpack_public_path__ + "static/media/Public.0a6451838be41ce61d777f472e5b8a3b.svg";
export { ForwardRef as ReactComponent };